import createDOMPurify from 'dompurify';

const VIDEO_HOSTS = ['www.youtube-nocookie.com', 'player.vimeo.com'];

const purify = createDOMPurify(window);

purify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'IFRAME') {
        let host = '';
        try {
            host = new URL(node.getAttribute('src') ?? '').hostname;
        } catch {
            // sem src valido, o host fica vazio e o iframe sai
        }
        if (!VIDEO_HOSTS.includes(host)) node.remove();
    }
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Segunda limpeza, ja no navegador. A primeira acontece no servidor ao salvar;
 * esta segura o conteudo caso algo tenha entrado no banco por outro caminho.
 */
export function sanitizeRichContent(html: string): string {
    return purify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'h2', 'h3', 'ul', 'ol', 'li', 'blockquote', 'a', 'iframe', 'img', 'video'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'loading', 'allowfullscreen', 'frameborder', 'controls', 'preload', 'playsinline', 'data-asset-id'],
        ALLOWED_URI_REGEXP: /^https:/i,
        // O DOMPurify aplica a regra acima a todo atributo fora desta lista, e sem
        // isto apagaria estes, cujos valores nao sao URLs.
        ADD_URI_SAFE_ATTR: ['allowfullscreen', 'frameborder', 'loading', 'controls', 'preload', 'playsinline'],
    });
}
